import styled from "styled-components";
export const AllVisitsStyle = styled.div``;
